export default __webpack_public_path__ + "static/media/minus-square-solid.e14f7f38.png";